import { useCallback, useContext, useState } from "react";
import { AuthContext, AuthContextValue } from "./AuthProvider";
import { ApiError, toApiError } from "../network/mainClient/apiError";
import { TFactor } from "../models/Factors";

type ResendFactorResult = {
  authSessionId: string;
  factor: TFactor;
};

export const useResendFactor = (): [
  ResendFactorResult | null,
  boolean,
  ApiError | null,
  (authSessionId: string, identity: string, factorId: string) => Promise<void>
] => {
  const { resendFactor } = useContext<AuthContextValue>(AuthContext);
  const [result, setResult] = useState<ResendFactorResult | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [error, setError] = useState<ApiError | null>(null);

  const request = useCallback(
    async (authSessionId: string, identity: string, factorId: string) => {
      setIsLoading(true);
      setError(null);

      try {
        const response = await resendFactor(authSessionId, identity, factorId);
        setResult(response);
      } catch (e) {
        setError(toApiError(e));
        throw e;
      } finally {
        setIsLoading(false);
      }
    },
    [resendFactor]
  );

  return [result, isLoading, error, request];
};
